import { render, staticRenderFns } from "./AppDetailTab8.vue?vue&type=template&id=41eb7dc1&scoped=true";
import script from "./AppDetailTab8.vue?vue&type=script&lang=js";
export * from "./AppDetailTab8.vue?vue&type=script&lang=js";
import style0 from "./AppDetailTab8.vue?vue&type=style&index=0&id=41eb7dc1&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "41eb7dc1", null);
export default component.exports;